<elder-basic-pane-layout class="full">
  <elder-pane class="">
    <elder-table
      class="flex"
      [elderTableActivation]="{ autoActivation: 'always', autoActivateItem: 'first' }"
      matSort
      [data]="data"
      [idField]="'id'"
      [interactionMode]="'selection'"
      [selectionVisible]="true"
      [selectionMultiEnabled]="false"
      (activeItemChange)="activeSchedule = $event"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="onCreate($event)"
        (requestRemove)="onRemoveAll($event)"
        [canRemove]="true"
        [canAdd]="canAdd$ | async"
        [canMore]="false"
      >
      </elder-data-toolbar>

      <!-- name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 40%" mat-sort-header="name">
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let schedule">{{ schedule.name }}</td>
      </ng-container>

      <!-- intervalStart -->
      <ng-container matColumnDef="intervalStart">
        <th mat-header-cell *matHeaderCellDef style="width: 40%" mat-sort-header="interval.start">
          {{ 'context.start' | translate }}
        </th>
        <td mat-cell *matCellDef="let schedule">
          {{
            (schedule.validityInterval | isoIntervalParse)?.start?.toString() | date: 'dd.MM.yyyy'
          }}
        </td>
      </ng-container>

      <!-- intervalEnd -->
      <ng-container matColumnDef="intervalEnd">
        <th mat-header-cell *matHeaderCellDef style="width: 40%" mat-sort-header="interval.end">
          {{ 'context.end' | translate }}
        </th>
        <td mat-cell *matCellDef="let schedule">
          {{ (schedule.validityInterval | isoIntervalParse)?.end?.toString() | date: 'dd.MM.yyyy' }}
        </td>
      </ng-container>

      <!-- duplicate button -->
      <ng-container matColumnDef="duplicate">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let schedule">
          <div class="place-start-center">
            <button
              mat-icon-button
              (click)="onDuplicateSchedule(schedule)"
              elderStopEventPropagation
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>

  <elder-pane class="flex layout-col">
    <app-work-schedule-detail
      class="flex"
      [schedule]="activeSchedule$ | async"
      (scheduleChange)="onScheduleChanged($event)"
    >
    </app-work-schedule-detail>
  </elder-pane>
</elder-basic-pane-layout>
